import { daysBetween, easternToday, shiftDays } from "./easternTime";

const MAX_RANGE_DAYS = 366;

export const lastDays = (days) => {
  const endDate = easternToday();
  return { startDate: shiftDays(endDate, 1 - days), endDate };
};

export const isComplete = ({ startDate, endDate }) => Boolean(startDate && endDate);

export const rangeProblem = ({ startDate, endDate }) => {
  if (startDate > endDate) return "From must be on or before To.";
  if (endDate > easternToday()) return "To cannot be after today.";
  if (daysBetween(startDate, endDate) > MAX_RANGE_DAYS) return "Date range cannot exceed 366 days.";
  return null;
};
